import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-doccard',
  templateUrl: './doccard.component.html',
  styleUrls: ['./doccard.component.css']
})
export class DoccardComponent implements OnInit {
  isDashboard: boolean = true;
  isSummary: boolean = false;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  constructor(
    private breakpointObserver: BreakpointObserver
  ) {
    console.log("here in log card constructor");
  }

  ngOnInit() {
    console.log("here in log card init");
  }

  toggleDashboard() {
    console.log("toggling dashboard");
    this.isDashboard = !this.isDashboard;
    console.log(this.isDashboard);
  }

  toggleSummary() {
    console.log("toggling food log");
    this.isSummary = !this.isSummary;
    console.log(this.isSummary);
  }

}
